import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import type React from 'react';
import type { CompanyQuoteStatus } from 'services/types/insuranceQuoteForm';
import { NAVY } from 'styles/tokens';

const TEAL = '#25616F';

interface QuoteProgressColumnProps {
  companies: CompanyQuoteStatus[];
}

const QuoteProgressColumn: React.FC<QuoteProgressColumnProps> = ({ companies }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <Box sx={{ px: 2, py: 1.5 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: NAVY }}>
        Cotizando...
      </Typography>
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {companies.length} aseguradora{companies.length !== 1 ? 's' : ''} en proceso
      </Typography>
    </Box>
    <List disablePadding>
      {companies.map((company) => (
        <ListItem key={company.name} sx={{ py: 1, px: 2 }}>
          <CircularProgress
            size={18}
            sx={{
              mr: 1.5,
              color: TEAL,
              animation: 'pulse 1.5s ease-in-out infinite',
              '@keyframes pulse': {
                '0%, 100%': { opacity: 1 },
                '50%': { opacity: 0.4 },
              },
            }}
          />
          <ListItemText
            primary={company.displayName}
            slotProps={{
              primary: { variant: 'body2', sx: { color: NAVY } },
            }}
          />
        </ListItem>
      ))}
    </List>
  </Box>
);

export default QuoteProgressColumn;
